import React from 'react';

const NotFoundPage: React.FC = () => {	
	return (
		<div className="min-h-screen">
      Not found
		</div>
	);
};

export default NotFoundPage;